export default __webpack_public_path__ + "6ea44145b4082f2afc01bb07c59446b3.png";